import { render, staticRenderFns } from "./InventoriesAndRefillsPanel.vue?vue&type=template&id=7a0c314a&scoped=true"
import script from "./InventoriesAndRefillsPanel.vue?vue&type=script&lang=js"
export * from "./InventoriesAndRefillsPanel.vue?vue&type=script&lang=js"
import style0 from "./InventoriesAndRefillsPanel.vue?vue&type=style&index=0&id=7a0c314a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0c314a",
  null
  
)

export default component.exports